export default {
  namespaced: true,
  state: {
    opened: false,
    text: '',
    onAccept: () => {},
    onCancel: () => {},
  },
  mutations: {
    close(state) {
      state.opened = false;
      state.text = '';
      state.onAccept = () => {};
      state.onCancel = () => {};
    },
    open(state, opts) {
      state.opened = true;
      state.text = opts.text;
      state.onAccept = opts.onAccept || (() => {});
      state.onCancel = opts.onCancel || (() => {});
    },
    switch(state) {
      state.opened = !state.opened;
    },
  },
  actions: {
    
  },
  getters: {
    isOpened(state) {
      return state.opened;
    },
    text(state) {
      return state.text;
    },
    onAccept(state) {
      return state.onAccept;
    },
    onCancel(state) {
      return state.onCancel;
    },
  }
};;
